import CacheUtil from '@/assets/utils/CacheUtil';

export default {
    methods: {
        parsedFieldValue_0( _type, _value, _each) {
          if ( !_value ) {
            return _value;
          }

          if ( 'budo_date' == _type ) {
            return this.dateFormat_0('YYYY-mm-dd', _value );
          }
    
          if ( 'time' == _type ) {
            return this.dateFormat_0('HH:MM:SS', _value );
          }
    
          if ( 'month' == _type ) {
            return this.dateFormat_0('YYYY-mm', _value );
          }
    
          if ( 'week' == _type ) {
            return this.dateFormat_0('YYYY-mm-dd', _value ) + '周';
          }
    
          if ( 'date_range' == _type || 'date_range_vertical' == _type ) {
            return this.dateFormat_0('YYYY-mm-dd', _value[0] ) + " ~ " + this.dateFormat_0('YYYY-mm-dd', _value[1] );
          }
    
          if ( 'time_range' == _type || 'time_range_vertical' == _type ) {
            return this.dateFormat_0('HH:MM:SS', _value[0] ) + " ~ " + this.dateFormat_0('HH:MM:SS', _value[1] );
          }
    
          if ( 'datetime_range' == _type ) {
            return this.dateFormat_0('YYYY-mm-dd HH:MM:SS', _value[0] ) + " ~ " + this.dateFormat_0('YYYY-mm-dd HH:MM:SS', _value[1] );
          }
    
          if ( 'merchant' == _type || 'merchant_vertical' == _type || 'merchant_linkage' == _type ) {
            return _each.merchantName + '(' + _value + ')';
          }
    
          if ( 'order' == _type || 'order_vertical' == _type || 'order_linkage' == _type ) {
            return _each.orderCode + '(' + _value + ')';
          }

          if ( 'enum' == _type ) {
            return _each.enumlabel + '(' + _value + ')';
          }

          if ( 'merchant_order_vertical_linkage' == _type || 'merchant_order_vertical' == _type ) {
            return _value + '(' + _each.order.id + ')';
          }
    
          if ( 'ticket_user' == _type || 'ticket_user_vertical' == _type ) {
            var _val = localStorage.getItem(CacheUtil.TicketUserListCache) || "[]";
            var _ticketUserList = JSON.parse(_val);

            var selected = _ticketUserList.filter(e => e.id == _value);
            if ( !selected || selected.length < 1 ) {
              console.log('#60 selected=', selected, ', _value=', _value, ', _value[_index]=', _value[_index], ', _ticketUserList=', _ticketUserList);
              return null;
            }

            return selected[0].name + '(' + selected[0].loginName + ', ' + _value + ')';
          }

          if ( 'multi_ticket_user' == _type || 'multi_ticket_user_vertical' == _type ) {
            var _val = localStorage.getItem(CacheUtil.TicketUserListCache) || "[]";
            var _ticketUserList = JSON.parse(_val);

            // 类型转换
            if ( _value.indexOf('[') > -1 ) {
              _value = JSON.parse('[' + _value + ']');
            }

            var users = [];
            for ( var _index in _value ) {
              var selected = _ticketUserList.filter(e => e.id == _value[_index]);
              if ( !selected || selected.length < 1 ) {
                console.log('#70 selected=', selected, ', _value=', _value, ', _value[_index]=', _value[_index], ', _ticketUserList=', _ticketUserList);
                continue;
              }

              var _each = selected[0].name + '(' + selected[0].loginName + ', ' + selected[0].id + ')';
              users.push(_each);
            }

            return users.join(', ');
          }

          console.log('#32 parsedFieldValue_0 ', _type, _each);
          return _value;
        },
    
        parsedFieldValueBefore ( _each ) {
          return this.parsedFieldValue_0( _each.fieldType, _each.fieldValueBefore, _each);
        },
    
        parsedFieldValue( _each ) {
          return this.parsedFieldValue_0( _each.fieldType, _each.fieldValue, _each);
        },

        // 时间格式处理
        parsePropertyValue( _e ) {
          if ( 'datetime_range' == _e.type || 'date_range' == _e.type || 'time_range' == _e.type //
            || 'datetime_range_vertical' == _e.type || 'date_range_vertical' == _e.type || 'time_range_vertical' == _e.type ) {
            var val = JSON.parse( _e['_value'] || "[]" );
            var a = !val[0] ? val[0] : val[0].replace("T", " ").replace(".000Z", "");
            var b = !val[1] ? val[1] : val[1].replace("T", " ").replace(".000Z", "");
    
            return [a, b];
          }

          if ( 'upload_vertical' == _e.type || 'upload' == _e.type ) {
            var val = JSON.parse( _e['_value'] || "{}");
            return val;
          }

          if ( 'boolean_vertical' == _e.type || 'boolean' == _e.type ) {
            var val = _e['_value'] || null;
            if ( 0 == val ) {
              return false;
            }

            return val;
          }

          if ( 'summernote_vertical' == _e.type || 'long' == _e.type || 'long_vertical' == _e.type || 'string' == _e.type || 'string_vertical' == _e.type // 
            || 'slider' == _e.type || 'slider_vertical' == _e.type || 'shop' == _e.type || 'shop_vertical' == _e.type || 'textarea_vertical' == _e.type //
            || 'radio_vertical' == _e.type || 'checkbox' == _e.type || 'checkbox_vertical' == _e.type || 'auth' == _e.type || 'auth_vertical' == _e.type //
            || 'enum' == _e.type || 'merchant_order_vertical_linkage' == _e.type || 'budo_date' == _e.type || 'ticket_user' == _e.type || 'radio' == _e.type // 
            || 'rate' == _e.type || 'rate_vertical' == _e.type) {
            return _e['_value'];
          }

          console.log('#210 parsePropertyValue', _e.type, _e);
          return _e['_value'];
        },

        isVertical(e) {
          return !!e && !!e.type && ( e.type.indexOf('_vertical') > -1 || 'divider' === e.type );
        },

        isDivider(e) {
          return !!e && !!e.type && e.type.indexOf('divider') > -1;
        },

        arrayUnique(arr) {
          return arr.filter(function(item, index, arr) {
            return arr.indexOf(item, 0) === index;
          });
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/TicketFormSupport.js